// extracted by mini-css-extract-plugin
module.exports = {"exception":"Exception_exception__3aFkG","exceptionImage":"Exception_exceptionImage__2FKV-","statuscode":"Exception_statuscode__14vt9","description":"Exception_description__2wcdF"};